// METIS Hub wording — namespace "connect" (ko), 505 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/connect.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const connect: Record<string, string> = {
  'connect.approval.title': 'VS Code 연결 승인',
  'connect.approval.titleCli': 'CLI(터미널) 연결 승인',
  'connect.approval.description': '이 계정으로 확장과 CLI를 연결합니다.',
  'connect.approval.account': '연결할 계정',
  'connect.approval.app': '앱',
  'connect.approval.server': 'Hub 서버',
  'connect.approval.code': '확인 코드',
  'connect.approval.recording': '이 앱의 사용량과 사용 기록은 위 계정에 저장됩니다. 기존 기록 동의와 회사 정책이 적용됩니다.',
  'connect.approval.text': '질문과 답변은 동의한 범위 안에서 기록됩니다. OpenAI·Anthropic API 키는 서버에 보관됩니다.',
  'connect.approval.meta': 'API 대화는 사용량만 기록합니다. 질문·답변 본문은 이 연결 토큰으로 저장하지 않습니다.',
  'connect.approval.providers': '사용 가능한 API',
  'connect.approval.noProviders': '현재 연결 가능한 API가 없습니다. CLI 수집 연결은 사용할 수 있으며, API 대화는 관리자가 OpenAI·Anthropic API와 모델을 설정한 후 연결해 주세요.',
  'connect.approval.checkCode': '직접 시작한 요청인지 확인하고, 확장이나 터미널에 표시된 코드와 일치하면 승인하세요. 요청은 10분 후 만료됩니다.',
  'connect.approval.approve': '연결 승인',
  'connect.approval.deny': '거절',
  'connect.approval.approved': '승인했습니다. 확장이나 터미널에서 연결을 마무리하고 있습니다.',
  'connect.approval.consumed': '연결되었습니다. VS Code나 터미널로 돌아가 사용하세요. 이 창은 닫아도 됩니다.',
  'connect.approval.denied': '연결 요청을 거절했습니다.',
  'connect.approval.cancelled': '확장이나 터미널에서 연결 요청을 취소했습니다.',
  'connect.approval.expired': '연결 요청이 만료되었습니다. 확장의 웹으로 연결을 다시 누르거나 터미널에서 prs login을 다시 실행하세요.',
  'connect.approval.failed': '이 연결 요청을 열거나 처리할 수 없습니다. 확장의 웹으로 연결을 다시 누르거나 터미널에서 prs login을 다시 실행하세요.',
  'connect.approval.limitTitle': '활성 토큰 한도 때문에 지금은 승인할 수 없습니다',
  'connect.approval.limitBody': '이 계정의 활성 토큰은 {active}/{limit}개이고, 이 연결에는 토큰 {needed}개가 새로 필요합니다. 도구 연결에서 쓰지 않는 연결을 끊거나 앱 연결(API 키)을 폐기해 {free}개 이상 줄이면 이 화면에서 바로 승인할 수 있습니다.',
  'connect.approval.limitAction': '도구 연결 열기 (새 탭)',
  "connect.download.title": "CLI·VS Code 확장 설치",
  "connect.download.desc": "터미널이나 확장에서 사용하고, 본인 기록을 웹에서 확인하세요.",
  "connect.download.windows": "Windows CLI 설치",
  "connect.download.portable": "CLI 실행 파일",
  "connect.download.npm": "npm 설치 파일",
  "connect.download.extension": "VS Code 확장",
  "connect.download.unavailable": "설치 파일을 아직 배포하지 않았거나 불러오지 못했습니다.",
  "connect.download.help": "CLI: 설치 후 prs login으로 웹 로그인 (prs가 다른 프로그램과 겹치면 prsx login) · 확장: VSIX에서 설치 → 웹으로 로그인. 토큰을 입력하지 않아요.",
  "connect.setup.title": "개발 도구 한 번에 설치",
  "connect.setup.desc": "Node.js(npm) · Git · GitLab CLI · Codex · Claude Code · METIS CLI를 스크립트로 설치해요. 이미 설치된 도구는 건너뛰어요.",
  "connect.setup.os": "운영체제",
  "connect.setup.packages": "설치할 도구",
  "connect.setup.pkg.node": "Node.js · npm",
  "connect.setup.pkg.git": "Git",
  "connect.setup.pkg.glab": "GitLab CLI",
  "connect.setup.pkg.codex": "Codex CLI",
  "connect.setup.pkg.claude": "Claude Code",
  "connect.setup.pkg.metis": "METIS CLI (prs)",
  "connect.setup.upgrade": "이미 있는 도구도 업데이트",
  "connect.setup.upgradeD": "끄면 설치된 도구는 건너뛰어요.",
  "connect.setup.copy": "설치 명령 복사",
  "connect.setup.note.windows": "PowerShell에 붙여 넣어 실행하세요. Node.js · Git을 설치할 때 관리자 확인(UAC) 창이 뜰 수 있어요. 끝나면 새 터미널을 여세요.",
  "connect.setup.note.mac": "터미널에 붙여 넣어 실행하세요. Homebrew가 없으면 먼저 설치하며 Mac 암호를 물을 수 있어요. 끝나면 새 터미널을 여세요.",
  "connect.setup.note.linux": "터미널에 붙여 넣어 실행하세요. sudo 없이 실행하면 필요할 때만 sudo 암호를 물어요. 끝나면 새 터미널을 여세요.",
  "connect.setup.options": "옵션 없이 실행하면 메뉴에서 고를 수 있어요. 상태 보기 -List / --list, 미리 보기 -DryRun / --dry-run.",
  "connect.setup.file": "스크립트 직접 받기 ({file})",
  "connect.download.server": "설치 파일의 기본 연결 서버: {url} · 다른 서버는 prs server set 주소, 또는 VS Code 명령 'METIS Hub: 서버 주소 변경'으로 바꿀 수 있어요.",
  "connect.download.serverOther": "설치 파일의 기본 서버가 이 Hub 주소와 달라요",
  "connect.download.serverOtherD": "설치 파일은 {file}에 연결하도록 만들어졌고, 이 Hub 주소는 {hub}예요. 관리자는 .env의 APP_DOMAIN을 확인한 뒤 설치 파일을 다시 빌드하세요.",
  "connect.desc": "내 PC의 Claude Code·Codex 연결과 앱·스크립트의 API 키 연결을 여기서 확인하고 고쳐요.",
  "connect.tabsLabel": "도구 연결 메뉴",
  "connect.tab.mine": "내 연결",
  "connect.tab.new": "새로 연결하기",
  "connect.tab.app": "앱 연결(API 키)",
  "connect.tab.team": "팀 연결 상태",
  "connect.tab.support": "지원표",
  "connect.tab.coverage": "무엇이 기록되나요",
  "connect.noTab.title": "이 탭을 볼 권한이 없어요",
  "connect.noTab.desc": "팀 연결 상태는 사람·팀 보기 권한이 있는 매니저·관리자가 봐요.",
  "connect.alert.reconsentDesc": "다시 동의하기 전까지 새 기록은 저장하지 않아요. 도구 연결은 그대로예요.",
  "connect.alert.pausedDesc": "멈춘 동안 받은 기록은 저장하지 않아요.",
  "connect.alert.go": "내 기록·동의에서 보기",
  "connect.mine.q": "내 PC는 기록을 잘 보내고 있나요?",
  "connect.mine.tech": "연결 상태 · 마지막 수신 기준 · PC × 도구",
  "connect.mine.sumOk": "연결 {n}개가 모두 잘 보내고 있어요.",
  "connect.mine.sumSome": "연결 {n}개 중 {bad}개를 살펴보세요.",
  "connect.mine.sumRevoked": "끊은 연결 {r}개는 기록을 받지 않아요.",
  "connect.mine.emptyWhat": "아직 연결한 도구가 없어요.",
  "connect.mine.emptyNot": "연결하기 전 기록은 남지 않아요. 연결하면 다음 질문부터 기록돼요.",
  "connect.dev.since": "처음 연결 {date}",
  "connect.dev.rename": "이름 바꾸기",
  "connect.dev.history": "연결 기록",
  "connect.mode.direct": "서버로 바로 보냄",
  "connect.mode.helper": "PC 도우미를 거쳐 보냄",
  "connect.f.lastRel": "마지막 수신 {rel}",
  "connect.f.never": "받은 기록 없음",
  "connect.f.version": "CLI 버전",
  "connect.f.token": "수집 전용 토큰",
  "connect.f.mode": "보내는 방식",
  "connect.f.revokedAt": "{rel}에 연결을 끊었어요",
  "connect.f.noToken": "연결 토큰 없음",
  "connect.f.lastUsedRel": "마지막 사용 {rel}",
  "connect.more": "자세히",
  "connect.less": "접기",
  "connect.token.noExpiry": "만료 없음 · 연결을 끊으면 폐기",
  "connect.token.expired": "만료됨",
  "connect.token.revoked": "폐기됨",
  "connect.token.expIn": "{d}일 뒤 만료 · {date}",
  "connect.ver.ok": "지원 버전",
  "connect.ver.checking": "지원 여부 확인 중",
  "connect.ver.old": "지원 버전보다 낮음",
  "connect.ver.unknown": "버전 모름",
  "connect.warn.over.title": "설정이 동의보다 많이 보내요",
  "connect.warn.over.desc": "이 PC의 CLI 설정에서 {what} 설정이 켜져 있어요. 기록 수준 {lv}에 없는 값이라 서버가 저장하기 전에 버리고 있어요.",
  "connect.warn.over.descPolicy": "이 PC의 CLI 설정에서 {what} 설정이 켜져 있어요. 회사 정책에서 꺼 둔 값이라 서버가 저장하기 전에 버리고 있어요.",
  "connect.over.prompt": "질문 글 보내기",
  "connect.over.answer": "AI 답변 글 보내기",
  "connect.over.work_detail": "작업 상세(명령·파일 경로) 보내기",
  "connect.over.raw": "AI 요청·응답 원본 보내기",
  "connect.tech": "기술 상세 보기",
  "connect.tech.find": "설정 파일에서 이 이름을 찾아요",
  "connect.warn.legacy.title": "옛 PoC 설정이 남아 있어요",
  "connect.warn.legacy.desc": "PC 점검 도구가 옛 시험 서버 주소({addr})를 찾았어요. 기록이 두 곳으로 가거나 빠질 수 있어요.",
  "connect.warn.legacy.fix": "정리 방법 보기",
  "connect.warn.problem.token": "새 연결 토큰을 받아 설정을 다시 적용하세요.",
  "connect.warn.problem.helper": "PC를 켜고 PC 도우미를 다시 시작하세요. 쌓인 기록은 다시 연결되면 보내요.",
  "connect.warn.problem.fix": "새 연결 토큰 받기",
  "connect.warn.idle": "쓰지 않았다면 괜찮아요. 썼는데 기록이 없다면 [시험 기록 확인]을 눌러 보세요.",
  "connect.act.test": "시험 기록 확인",
  "connect.act.reconfig": "설정 다시 받기",
  "connect.act.revoke": "연결 끊기",
  "connect.act.reconnect": "다시 연결하기",
  "connect.test.title": "시험 기록 확인",
  "connect.test.wait": "이 PC에서 새 터미널을 열고 질문 하나를 보내 보세요. {tool}에서 오는 기록을 기다리고 있어요…",
  "connect.test.checking": "받은 시험 기록을 확인하는 중이에요…",
  "connect.test.ok": "방금 시험 기록을 받았어요",
  "connect.test.okMeta": "{time} · {tool} {ver} · {pc}",
  "connect.test.miss": "아직 받지 못했어요",
  "connect.test.missDesc": "아래를 차례로 확인해 보세요.",
  "connect.chk.legacy.t": "옛 PoC 설정이 남아 있어요",
  "connect.chk.legacy.d": "기록이 옛 주소로 가고 있을 수 있어요. 먼저 정리하세요.",
  "connect.chk.terminal.t": "새 터미널에서 보냈나요?",
  "connect.chk.terminal.d": "설정은 새로 연 터미널부터 적용돼요.",
  "connect.chk.token.t": "연결 토큰이 맞나요?",
  "connect.chk.token.d": "③에서 받은 수집 전용 토큰과 같은지 보세요. 잃어버렸다면 새로 받으세요.",
  "connect.chk.format.t": "보내는 형식이 맞나요?",
  "connect.chk.format.d": "설정의 보내는 형식이 http/json인지 보세요.",
  "connect.chk.addr.t": "수집 서버 주소에 닿나요?",
  "connect.chk.addr.d": "{addr}에 닿는지 회사망·VPN을 확인하세요.",
  "connect.chk.help": "도움말",
  "connect.path.label": "기록이 가는 길",
  "connect.path.pc": "내 PC의 AI 도구",
  "connect.path.server": "회사 수집 서버",
  "connect.path.store": "저장",
  "connect.path.sent": "보냄",
  "connect.path.got": "받음",
  "connect.path.stored": "저장함",
  "connect.path.checkPc": "보내는 설정을 확인하세요",
  "connect.path.notReached": "닿지 않음",
  "connect.path.dropped": "저장하기 전에 버림",
  "connect.path.stop": "여기서 멈췄어요",
  "connect.path.sum.ok": "세 구간을 모두 지나 저장했어요.",
  "connect.path.sum.dropped": "회사 수집 서버까지는 왔고, 저장하기 전에 멈췄어요.",
  "connect.path.sum.missed": "내 PC에서 회사 수집 서버로 가는 사이에서 멈췄어요.",
  "connect.flow.label": "진행 상태",
  "connect.flow.wait": "대기",
  "connect.flow.check": "확인 중",
  "connect.flow.done": "완료",
  "connect.flow.missed": "못 받음",
  "connect.flow.dropped": "저장 안 함",
  "connect.flow.sr.done": "끝남",
  "connect.flow.sr.now": "지금 단계",
  "connect.flow.sr.fail": "여기서 멈춤",
  "connect.revoke.title": "{tool} 연결을 끊을까요?",
  "connect.revoke.body": "{pc}의 수집 전용 토큰을 폐기해요. 이 PC의 {tool}{ga} 보내는 기록을 더 받지 않아요. 지금까지 받은 기록은 그대로 남아요.",
  "connect.revoke.bodyOther": "{name} 님 {pc}의 {tool} 수집 전용 토큰을 폐기해요. 이 일은 열람·변경 이력에 남고 본인에게 알려요.",
  "connect.revoke.confirm": "연결 끊기",
  "connect.revoke.done": "연결을 끊었어요. 수집 전용 토큰을 폐기했어요.",
  "connect.rename.title": "PC 이름 바꾸기",
  "connect.rename.label": "PC 이름",
  "connect.rename.hint": "기본 이름은 PC-1 같은 형식이에요. 관리자·운영 담당도 이 이름을 봐요. 실명이나 PC 호스트 이름은 넣지 마세요.",
  "connect.rename.save": "저장",
  "connect.rename.done": "PC 이름을 바꿨어요.",
  "connect.rename.err": "1~30자로 입력하세요.",
  "connect.hist.title": "{pc} 연결 기록",
  "connect.hist.note": "이 PC의 연결이 바뀐 때만 보여요(질문 내용은 없어요).",
  "connect.hist.add": "{tool} 연결 · 수집 전용 토큰을 받았어요",
  "connect.hist.first": "{tool} 첫 기록을 받았어요",
  "connect.hist.version": "{tool} 버전이 바뀌었어요: {v}",
  "connect.hist.last": "{tool} 마지막 기록을 받았어요",
  "connect.hist.quiet": "{tool} 한동안 조용해졌어요(4시간 넘게 기록 없음)",
  "connect.hist.down": "{tool} 연결 안 됨으로 바뀌었어요(3일 넘게 기록 없음)",
  "connect.hist.revoked": "{tool} 연결을 끊었어요 · 수집 전용 토큰 폐기",
  "connect.hist.level": "기록 수준을 바꿨어요: {lv}",
  "connect.hist.problem": "{tool} 오류: {why}",
  "connect.legacy.title": "옛 PoC 설정 정리하기",
  "connect.legacy.desc": "아래 명령은 백업을 만든 뒤 옛 시험 서버 주소·헤더만 지워요. 내가 바꾼 다른 설정은 그대로 둬요.",
  "connect.legacy.done": "정리했어요",
  "connect.legacy.doneToast": "옛 PoC 설정을 정리했다고 표시했어요. 다음 기록부터 확인해요.",
  "connect.legacy.copy": "정리 명령 복사",
  "connect.wz.label": "연결 마법사 단계",
  "connect.wz.progress": "{i}/{n}단계 · {label}",
  "connect.wz.s.level": "기록 수준",
  "connect.wz.s.tool": "도구",
  "connect.wz.s.token": "연결 토큰",
  "connect.wz.s.apply": "설정 적용",
  "connect.wz.s.test": "시험 질문",
  "connect.wz.s.result": "결과",
  "connect.wz.level.q": "어디까지 남길지 먼저 골라요",
  "connect.wz.level.tech": "① 기록 수준 · 회사 상한 안에서 · 설정보다 먼저",
  "connect.wz.level.why": "수준마다 CLI가 보내야 하는 설정이 달라서, 설정을 만들기 전에 먼저 골라요.",
  "connect.wz.notice": "안내문 {v} 요약",
  "connect.wz.notice.purpose": "목적: AI 사용 비용·보안 관리예요. 근무·성과 평가에 쓰지 않아요.",
  "connect.wz.notice.keep": "보관: 질문·답변 글 {c}일 · 사용량·기본 정보 {u}일 뒤 자동 삭제",
  "connect.wz.notice.who": "볼 수 있는 사람: 나 · 관리자·원문 열람 담당(사유·다시 로그인 확인·대화 단위 허가를 거치고 나에게 표시돼요)",
  "connect.wz.notice.rights": "언제든 낮추거나 잠시 멈추고, 동의를 철회할 수 있어요.",
  "connect.wz.cap": "회사 상한: {lv}까지",
  "connect.wz.capOff": "{items}{eun} 회사가 꺼 두었어요",
  "connect.wz.current": "지금 내 기록 수준",
  "connect.wz.custom": "직접 고르기",
  "connect.wz.customHint": "항목을 따로 켜고 끌 수 있어요. 고른 조합이 단계와 같으면 그 단계로 보여요.",
  "connect.wz.customOn": "직접 고른 조합",
  "connect.lv.current": "지금",
  "connect.lv.sendLabel": "보내는 것",
  "connect.lv.notLabel": "보내지 않는 것",
  "connect.lv.withdrawLabel": "철회 방법",
  "connect.lv.withdraw": "내 기록·동의에서 언제든 낮추거나 멈춰요.",
  "connect.lv.capped": "회사 상한보다 높아 고를 수 없어요",
  "connect.lv1.send": "시각·도구·AI 모델·사용량·시간·성공 여부, 글자 수",
  "connect.lv1.not": "질문·답변 글, 명령, 파일 경로",
  "connect.lv2.send": "①에 더해 질문 글",
  "connect.lv2.not": "AI 답변 글, 명령·파일 경로·바뀐 내용",
  "connect.lv3.send": "②에 더해 AI 답변 글(Codex는 질문마다 마지막 답변 1건, 비공식)",
  "connect.lv3.not": "명령·파일 경로·바뀐 내용",
  "connect.lv4.send": "③에 더해 명령·파일 경로·바뀐 내용(Claude는 값마다 앞 128자까지)",
  "connect.lv4.not": "파일 내용·명령 출력(도구 결과), AI의 중간 생각",
  "connect.ci.basic": "연결하려면 늘 켜져 있어요",
  "connect.ci.prompt": "내가 쓴 질문 글을 보내요",
  "connect.ci.answer": "AI 답변 글을 보내요(Codex는 비공식 설정)",
  "connect.ci.work_detail": "명령·파일 경로·바뀐 내용을 보내요(Codex는 늘 보내고 서버가 걸러요)",
  "connect.ci.toolOutputRisk": "켜면 파일 내용·명령 출력 일부가 남아요",
  "connect.ci.techLead": "항목마다 CLI가 쓰는 설정 이름이에요(Claude Code · Codex). ④ 설정 적용의 명령이 알아서 바꿔요.",
  "connect.ci.codexAlways": "Codex는 따로 끄지 못해요(서버가 걸러요)",
  "connect.wz.levelNote": "바꾸면 동의 이력에 남고, 다른 PC의 CLI 설정도 다시 받아야 해요.",
  "connect.wz.levelSaved": "기록 수준을 바꿨어요: {lv} · 동의 이력에 남았어요",
  "connect.wz.coverage": "무엇이 기록되나요 보기",
  "connect.wz.consentWarn": "안내문 {v}에 동의하기 전이라, 연결해도 새 기록은 저장하지 않아요.",
  "connect.wz.tool.q": "어떤 AI 도구를 연결할까요?",
  "connect.wz.tool.tech": "② 도구 · CLI 도구(Claude Code · Codex)",
  "connect.tool.claude_code.sub": "Anthropic의 코딩 AI 도구 · {v} 이상",
  "connect.tool.codex.sub": "OpenAI의 코딩 AI 도구 · {v} 이상",
  "connect.tool.claude_code.file": "내 사용자 설정 파일(JSON)에만 써요",
  "connect.tool.codex.file": "내 사용자 설정 파일(TOML)에만 써요",
  "connect.tool.connected": "이미 연결함 · {pc}",
  "connect.wz.tool.api": "API 키로 AI를 부르는 앱·스크립트는 앱 연결에서 연결해요.",
  "connect.wz.tool.apiGo": "앱 연결(API 키)로 가기",
  "connect.wz.tool.locked": "설정 다시 받기에서는 도구를 바꿀 수 없어요.",
  "connect.wz.token.q": "이 PC 전용 연결 토큰을 받으세요",
  "connect.wz.token.tech": "③ 수집 전용 토큰 · 지금 한 번만 보여요",
  "connect.wz.token.which": "어느 PC인가요?",
  "connect.wz.token.newPc": "새 PC",
  "connect.wz.token.pcName": "새 PC 이름",
  "connect.wz.token.pcHint": "기본 이름은 PC-1 같은 형식이에요. 실명이나 PC 호스트 이름은 넣지 마세요.",
  "connect.wz.token.replaceNote": "이 PC의 {tool} 연결 토큰을 새로 바꿔요. 이전 연결 토큰은 폐기돼요.",
  "connect.wz.token.can": "할 수 있는 일",
  "connect.wz.token.canV": "기록 보내기만(조회·관리 불가)",
  "connect.wz.token.bound": "묶이는 곳",
  "connect.wz.token.exp": "만료",
  "connect.wz.token.expV": "연결을 끊을 때까지",
  "connect.wz.token.issue": "수집 전용 토큰 받기",
  "connect.wz.token.issued": "수집 전용 토큰을 받았어요. 지금 복사해 두세요.",
  "connect.wz.token.once": "이 수집 전용 토큰은 지금 한 번만 보여요",
  "connect.wz.token.onceDesc": "이 마법사를 떠나면 다시 보여 주지 않아요. ④의 설정에는 자동으로 들어가요. 잃어버리면 새로 받고, 이전 연결 토큰은 폐기돼요.",
  "connect.wz.token.copy": "수집 전용 토큰 복사",
  "connect.wz.token.hidden": "받은 수집 전용 토큰은 이제 가려져요 · {masked}",
  "connect.wz.token.lost": "잃어버렸다면 새로 받으세요. 이전 연결 토큰은 폐기돼요.",
  "connect.wz.token.again": "새로 받기(이전 연결 토큰 폐기)",
  "connect.wz.token.reuse": "{pc}의 {tool} 설정을 다시 받아요.",
  "connect.wz.token.keep": "지금 쓰는 수집 전용 토큰({prefix}••••)을 그대로 써요",
  "connect.wz.token.keepDesc": "설정 파일 속 연결 토큰은 바꾸지 않고 기록 수준 줄만 바꿔요.",
  "connect.wz.token.replace": "새 연결 토큰으로 바꾸기",
  "connect.wz.needToken": "먼저 수집 전용 토큰을 받으세요.",
  "connect.wz.apply.q": "이 명령을 터미널에 붙여 넣어요",
  "connect.wz.apply.tech": "④ 설정 적용 · 사용자 설정 파일에만 써요",
  "connect.os.label": "운영체제",
  "connect.os.unix": "macOS·Linux",
  "connect.os.win": "Windows",
  "connect.apply.modeLabel": "적용 방식",
  "connect.apply.oneline": "한 줄 명령",
  "connect.apply.manual": "직접 붙여넣기",
  "connect.apply.onelineDesc": "기존 설정과 안전하게 합치고, 바꾸기 전에 백업을 만들어요. 이 명령에는 Node.js 24 이상이 필요해요. 설치되어 있지 않으면 직접 붙여넣기를 선택하세요. 프로젝트 폴더의 설정은 건드리지 않아요.",
  "connect.apply.askToken": "명령을 실행하면 ③의 연결 토큰을 물어봐요. 화면에 보이지 않게 입력되고 셸 기록에 남지 않아요.",
  "connect.apply.keepToken": "지금 쓰는 연결 토큰은 그대로 두고 기록 수준 줄만 바꿔요.",
  "connect.apply.manualDesc": "아래 파일을 열어 내용을 합쳐 넣으세요. ①에서 고른 기록 수준이 반영된 줄만 있어요.",
  "connect.apply.onlyLevel": "연결 토큰·주소 줄은 그대로 두고 아래 줄만 바꾸세요.",
  "connect.apply.file": "대상 파일",
  "connect.apply.lgLabel": "줄 표시",
  "connect.apply.lgOn": "기록 수준({lv})에 따라 켠 줄",
  "connect.apply.lgOff": "끄는 값(비워 두면 다른 값을 따라가요)",
  "connect.apply.restore": "되돌리기",
  "connect.apply.restoreDesc": "우리가 쓴 값만 백업한 원래 값으로 돌려요. 그 뒤에 직접 바꾼 값은 남겨요.",
  "connect.apply.noProject": "프로젝트 폴더의 .claude·.codex 설정에는 쓰지 않아요(연결 토큰이 저장소에 올라가지 않게).",
  "connect.apply.placeholder": "<③에서 받은 수집 전용 토큰>",
  "connect.apply.restart": "설정은 새로 연 터미널부터 적용돼요.",
  "connect.apply.noToken": "③에서 연결 토큰을 받으면 설정에 들어가요.",
  "connect.apply.copyCmd": "명령 복사",
  "connect.apply.goToken": "③ 연결 토큰 받으러 가기",
  "connect.apply.copyRestore": "되돌리기 명령 복사",
  "connect.apply.copyFile": "설정 내용 복사",
  "connect.apply.codexUnofficial": "# 비공식 · Codex 0.162.1 이상",
  "connect.apply.codexNote": "# 작업 상세(④)는 Codex가 늘 보내요. 서버가 기록 수준으로 걸러요.",
  "connect.apply.codexKeep": "# metrics_exporter·analytics는 바꾸지 않아요(OpenAI 자체 통계에 영향)",
  "connect.wz.test.q": "새 터미널을 열고 질문 하나를 보내 보세요",
  "connect.wz.test.tech": "⑤ 시험 질문 · 3분까지 기다려요",
  "connect.wz.test.s1": "지금 열려 있는 터미널을 닫고 새 터미널을 여세요.",
  "connect.wz.test.s2": "아래처럼 질문 하나를 보내세요.",
  "connect.wz.test.s3": "이 화면에서 첫 기록이 도착하는지 기다려요.",
  "connect.wz.test.prompt": "연결 시험이에요. 한 줄로 답해 주세요.",
  "connect.wz.test.copy": "시험 명령 복사",
  "connect.wz.test.waiting": "첫 기록을 기다리는 중이에요",
  "connect.wz.test.elapsed": "{t} 지남 · 3분까지 기다려요",
  "connect.wz.test.checking": "받은 기록을 확인하는 중이에요",
  "connect.wz.test.checkingSub": "저장할 수 있는지 보고 있어요",
  "connect.wz.demo": "목업: 결과 고르기",
  "connect.wz.check": "결과 확인",
  "connect.res.ok": "받음·저장됨",
  "connect.res.dropped": "받았지만 저장 안 함",
  "connect.res.missed": "3분 동안 못 받음",
  "connect.wz.result.q": "첫 기록이 잘 들어왔나요?",
  "connect.wz.result.tech": "⑥ 결과 · 받음·저장됨 / 받았지만 저장 안 함 / 3분 동안 못 받음",
  "connect.res.ok.title": "첫 기록이 도착했어요",
  "connect.res.ok.meta": "{time} · {tool} {ver} · {pc}",
  "connect.res.ok.saved": "기록 수준 {lv} 기준으로 저장했어요. 이 연결은 내 연결에 보여요.",
  "connect.res.ok.logs": "사용 기록에서 보기",
  "connect.res.ok.mine": "내 연결 보기",
  "connect.res.drop.title": "받았지만 저장하지 않았어요",
  "connect.res.drop.desc": "기록은 서버에 닿았어요. 아래 이유로 저장하기 전에 버렸어요.",
  "connect.res.drop.consent": "안내문 {v}에 동의하기 전에 보낸 기록이에요.",
  "connect.res.drop.paused": "기록을 잠시 멈춘 동안 보낸 기록이에요.",
  "connect.res.drop.level": "보낸 값 가운데 고른 기록 수준에 없는 것은 버렸어요(예: 수준 ①인데 질문 글).",
  "connect.res.drop.fixConsent": "동의하러 가기",
  "connect.res.drop.fixLevel": "기록 수준 다시 고르기",
  "connect.res.miss.title": "3분 동안 받지 못했어요",
  "connect.res.miss.desc": "아래를 차례로 확인한 뒤 다시 보내 보세요.",
  "connect.res.miss.back": "④ 설정 적용으로 돌아가기",
  "connect.res.miss.retry": "다시 시도",
  "connect.wz.prev": "이전",
  "connect.wz.next": "다음",
  "connect.wz.home": "홈으로",
  "connect.wz.restart": "처음부터 다시",
  "connect.wz.mobile.title": "AI 도구를 쓰는 PC에서 진행하세요",
  "connect.wz.mobile.tech": "새로 연결하기 · PC 터미널이 필요해요",
  "connect.wz.mobile.desc": "설정 명령은 그 PC의 터미널에 붙여 넣어야 해요. 이 링크를 PC로 보내 열어 보세요.",
  "connect.wz.mobile.copy": "링크 복사",
  "connect.wz.mobile.peek": "단계만 미리 보기",
  "connect.wz.mobile.copied": "링크를 복사했어요. PC에서 열어 보세요.",
  "connect.app.q": "앱·스크립트를 회사 게이트웨이로 어떻게 연결하나요?",
  "connect.app.tech": "API 키 호출 · 회사 게이트웨이 · 게이트웨이 토큰(만료 90일 이하)",
  "connect.app.sum": "앱이 회사 게이트웨이를 거쳐 AI를 부르면 사람·호출 단위로 기록돼요. 회사 키는 게이트웨이만 갖고, 앱에는 게이트웨이 토큰을 넣어요.",
  "connect.app.addr": "게이트웨이 주소",
  "connect.app.sep": "API 키로 쓴 양은 홈·통계의 ‘API 키 호출’로 따로 보여요.",
  "connect.app.tools": "Codex · Claude Code에는 이 토큰을 넣지 마세요. 터미널에서 prs codex · prs claude로 실행하면 회사 키가 있을 때 자동으로 이 게이트웨이를 써요(기본 codex · claude 명령은 본인 로그인 그대로).",
  "connect.app.src": "회사 게이트웨이(C3)",
  "connect.app.emptyWhat": "게이트웨이가 아직 켜지지 않았어요. 관리자에게 문의하세요.",
  "connect.app.emptyNot": "게이트웨이를 거치지 않은 API 키 호출은 사람별로 보이지 않아요. API 키를 안 쓴다는 뜻은 아니에요.",
  "connect.app.form": "게이트웨이 토큰 발급",
  "connect.app.name": "앱 이름",
  "connect.app.namePh": "예: support-summarizer",
  "connect.app.purpose": "목적",
  "connect.app.purposePh": "예: 고객 문의 요약",
  "connect.app.owner": "소유자",
  "connect.app.me": "나({name})",
  "connect.app.provider": "AI 회사",
  "connect.app.text": "글 저장 정책",
  "connect.app.text.meta": "기본 정보만(기본)",
  "connect.app.text.metaD": "시각·AI 모델·사용량·비용·상태만 남겨요.",
  "connect.app.text.full": "마지막 질문·답변도 저장",
  "connect.app.text.fullD": "소유자·목적·가림 규칙을 정해야 해요. 보관 7일.",
  "connect.app.text.needAdmin": "관리자 승인이 필요해요(직원 동의만으로는 켜지 않아요)",
  "connect.app.expiry": "만료(90일 이하)",
  "connect.app.days": "{n}일",
  "connect.app.issue": "게이트웨이 토큰 발급",
  "connect.app.err.name": "앱 이름을 입력하세요.",
  "connect.app.err.purpose": "목적을 입력하세요.",
  "connect.app.issued": "게이트웨이 토큰을 발급했어요. 지금 복사해 두세요.",
  "connect.app.once": "이 게이트웨이 토큰은 지금 한 번만 보여요",
  "connect.app.onceD": "회사 키를 쓰는 권한이라 남과 나누지 마세요. 만료 14일 전에 알려 드려요.",
  "connect.app.copy": "게이트웨이 토큰 복사",
  "connect.app.use": "앱에 넣는 방법",
  "connect.app.use.file": "파일 방식",
  "connect.app.use.helper": "도우미 명령 방식",
  "connect.app.use.fileD": "게이트웨이 토큰을 나만 읽을 수 있는 파일에 두고, 앱이 실행할 때만 읽어요. 코드나 저장소에 올리는 설정 파일에는 적지 마세요.",
  "connect.app.use.helperD": "필요할 때 도우미 명령이 게이트웨이 토큰을 꺼내 줘요. CLI 도구를 게이트웨이로 보내는 설정은 중복 확인이 끝날 때까지 안내하지 않아요.",
  "connect.app.another": "다른 앱 연결하기",
  "connect.gw.q": "내 게이트웨이 토큰은 언제 만료되나요?",
  "connect.gw.tech": "게이트웨이 토큰 · 만료 14일 전 알림",
  "connect.gw.sumSoon": "{app} 게이트웨이 토큰이 {d}일 뒤 만료돼요. 만료 전에 새로 발급하세요.",
  "connect.gw.sumOk": "게이트웨이 토큰 {n}개 모두 14일 넘게 남았어요.",
  "connect.gw.sumNone": "쓰고 있는 게이트웨이 토큰이 없어요.",
  "connect.gw.emptyWhat": "발급한 게이트웨이 토큰이 없어요.",
  "connect.gw.emptyNot": "게이트웨이를 거친 호출만 사람별로 보여요. API 키를 안 쓴다는 뜻은 아니에요.",
  "connect.gw.left": "{d}일 남음",
  "connect.gw.never": "쓴 적 없음",
  "connect.gw.soon": "{d}일 뒤 만료",
  "connect.gw.renew": "새로 발급",
  "connect.gw.revoke": "폐기",
  "connect.gw.renewAsk": "{app} 게이트웨이 토큰을 새로 발급할까요?",
  "connect.gw.renewAskD": "새 게이트웨이 토큰을 한 번만 보여 드려요. 이전 게이트웨이 토큰은 바로 폐기돼요.",
  "connect.gw.renewTitle": "새 게이트웨이 토큰 · {app}",
  "connect.gw.renewDone": "새 게이트웨이 토큰을 발급했어요. 이전 것은 폐기했어요.",
  "connect.gw.revokeTitle": "{app} 게이트웨이 토큰을 폐기할까요?",
  "connect.gw.revokeBody": "이 게이트웨이 토큰으로 부르는 앱은 바로 401 오류를 받아요.",
  "connect.gw.revokeDone": "게이트웨이 토큰을 폐기했어요.",
  "connect.keys.q": "어떤 API 키가 등록되어 있나요?",
  "connect.keys.tech": "API 키 등록부 · 끝 4자리만 보여요 · {scope}",
  "connect.keys.scopeAll": "회사 키 전체",
  "connect.keys.scopeMine": "내가 소유한 키",
  "connect.keys.sum": "키 {n}개 중 {a}개를 쓰고 있어요.",
  "connect.keys.sumGrace": "키 {n}개 중 {a}개를 쓰고 있고, {g}개는 교체 유예 중이에요.",
  "connect.keys.emptyWhat": "내 이름으로 등록된 API 키가 없어요.",
  "connect.keys.emptyNot": "회사 키는 관리자가 등록해요. 앱은 게이트웨이 토큰으로 회사 키를 써요.",
  "connect.keys.src.admin_api": "조직 연동",
  "connect.keys.src.manual": "직접 등록",
  "connect.keys.graceUntil": "{date}에 폐기",
  "connect.keys.rotate": "교체",
  "connect.keys.noManage": "키 교체·등록은 연동 관리 권한이 있는 사람만 해요.",
  "connect.keys.org": "조직 보고서는 키별 합계를 하루 단위로 알려 줘요(사람별 아님).",
  "connect.keys.src": "API 키 등록부",
  "connect.rot.title": "{alias} 키 교체",
  "connect.rot.st.active": "사용 중",
  "connect.rot.st.grace": "유예 7일",
  "connect.rot.st.revoked": "폐기",
  "connect.rot.desc": "새 키를 등록하면 지금 키는 7일 동안 유예로 두었다가 자동으로 폐기해요. 그동안 두 키 모두 쓸 수 있어요.",
  "connect.rot.newKey": "새 키(AI 회사 콘솔에서 받은 값)",
  "connect.rot.newKeyHint": "붙여 넣으면 암호화해 보관하고 끝 4자리만 남겨요. 다시 보여 주지 않아요.",
  "connect.rot.confirm": "교체 시작",
  "connect.rot.err": "새 키를 넣어 주세요(8자 이상).",
  "connect.rot.done": "교체를 시작했어요. 이전 키는 {date}에 폐기돼요.",
  "connect.team.q": "연결이 끊긴 사람이 있나요?",
  "connect.team.qTeam": "연결이 끊긴 팀원이 있나요?",
  "connect.team.tech": "사람 × 도구 · 끊김 먼저 · {scope}",
  "connect.team.scopeTeam": "우리 팀({team})",
  "connect.team.scopeAll": "전체",
  "connect.team.scopeAllTeam": "전체 · {team}만",
  "connect.team.sum": "{p}명 중 {bad}명의 연결을 살펴보세요.",
  "connect.team.sumErr": "오류로 끊긴 연결이 {e}개 있어요.",
  "connect.team.sumNone": "{p}명의 연결이 모두 괜찮아요.",
  "connect.team.filter": "보기",
  "connect.team.f.attention": "살펴볼 연결 {n}",
  "connect.team.f.all": "모두 {n}",
  "connect.team.allOk": "살펴볼 연결이 없어요",
  "connect.team.never": "연결한 적 없음",
  "connect.team.noRx": "받은 기록 없음",
  "connect.team.idle": "3일 넘게 받은 기록이 없으면 ‘연결 안 됨’이에요. 쓰지 않았다면 괜찮아요. 기록 없음 ≠ 안 씀.",
  "connect.team.excluded": "같은 팀의 다른 매니저·관리자·원문 열람 담당은 보이지 않아요({n}명).",
  "connect.team.revokeNote": "다른 사람 연결 끊기는 열람·변경 이력에 남고 본인에게 알려요.",
  "connect.team.emptyWhat": "조건에 맞는 사람이 없어요.",
  "connect.team.emptyNot": "보기 범위·팀을 바꿔 보세요.",
  "connect.col.person": "사람",
  "connect.col.team": "팀",
  "connect.col.tool": "도구",
  "connect.col.status": "상태",
  "connect.col.why": "이유",
  "connect.col.last": "마지막 수신",
  "connect.col.version": "CLI 버전",
  "connect.col.act": "할 일",
  "connect.col.app": "앱",
  "connect.col.provider": "AI 회사",
  "connect.col.expires": "만료",
  "connect.col.lastUsed": "마지막 사용",
  "connect.col.alias": "별칭",
  "connect.col.last4": "끝 4자리",
  "connect.col.keyId": "AI 회사 키 ID",
  "connect.col.workspace": "워크스페이스",
  "connect.col.owner": "소유자",
  "connect.col.source": "출처",
  "connect.col.kind": "종류",
  "connect.col.target": "대상",
  "connect.col.token": "연결 토큰",
  "connect.col.verState": "판정",
  "connect.col.pc": "도구 · PC",
  "connect.exp.q": "만료가 가까운 연결 토큰이 있나요?",
  "connect.exp.tech": "연결 토큰 · 14일 안에 만료 · 이미 만료",
  "connect.exp.sum": "{n}개가 14일 안에 만료되거나 이미 만료됐어요.",
  "connect.exp.sumNone": "14일 안에 만료되는 연결 토큰이 없어요.",
  "connect.exp.auto": "만료 14일 전에 본인에게 알림이 가요.",
  "connect.exp.needNew": "새 연결 토큰 필요",
  "connect.kind.collect": "수집 전용 토큰",
  "connect.kind.gateway": "게이트웨이 토큰",
  "connect.kind.service": "서비스 계정 토큰",
  "connect.sup.q": "어떤 도구가 어떤 값을 보내나요?",
  "connect.sup.tech": "지원표 · 도구·버전·OS·인증 방식 × 항목",
  "connect.sup.sum": "최소 지원 버전은 Claude Code {c} · Codex {x}이에요. 지원 여부를 확인하고 있는 새 버전: {chk}.",
  "connect.sup.none": "없음",
  "connect.sup.tool": "도구 · 버전 · OS · 인증",
  "connect.sup.region": "지원표(가로로 넘겨 볼 수 있어요)",
  "connect.sup.osNa": "OS 무관",
  "connect.sup.target": "이 배지에서 온 칸",
  "connect.sup.cellDate": "실측 확인 {date}",
  "connect.sup.src": "지원표 마지막 확인 {date}",
  "connect.sup.lg": "읽는 법",
  "connect.sup.lg.verified": "실제 CLI로 보내 보고 확인했어요",
  "connect.sup.lg.source": "공개된 소스 코드에서 확인했어요",
  "connect.sup.lg.doc": "공식 문서에서만 확인했어요(실측 전)",
  "connect.sup.lg.conditional": "설정·버전·기록 수준이 맞을 때만 와요",
  "connect.sup.lg.unofficial": "공식 목록에 없는 값이에요",
  "connect.sup.lg.unsupported": "도구가 보내지 않아요",
  "connect.sup.lg.na": "그 사용 방식엔 없는 값이에요",
  "connect.sup.lg.checking": "지원 여부를 확인하고 있어요",
  "connect.ver.q": "내 PC는 어떤 CLI 버전을 보냈나요?",
  "connect.ver.tech": "받은 CLI 버전 · 내 PC 기준",
  "connect.ver.sumOk": "내 PC의 CLI {n}개가 모두 지원 버전이에요.",
  "connect.ver.sumWarn": "{n}개 중 {w}개를 확인하세요.",
  "connect.ver.emptyWhat": "아직 받은 CLI 버전이 없어요.",
  "connect.ver.policy": "최소 지원 버전보다 낮으면 기본 정보만 저장하고 글·작업 상세는 받지 않아요. 실측하지 않은 버전은 동의한 범위대로 저장하고 ‘지원 여부 확인 중’ 배지를 붙여요. 버전 배지는 OS·인증 방식까지 검증했다는 뜻은 아니에요.",
  "connect.ver.latest": "확인한 최신 {v}",
  "connect.cov.q": "무엇을 기록할 수 있고 무엇은 못 하나요?",
  "connect.cov.tech": "항목 × 사용 방식 · 가능 · 조건부 · 불가 · 해당 없음",
  "connect.cov.sum": "같은 항목이라도 도구와 사용 방식에 따라 남는 것이 달라요. 칸을 누르면 조건이 보여요.",
  "connect.cov.y": "가능",
  "connect.cov.c": "조건부",
  "connect.cov.n": "불가",
  "connect.cov.na": "해당 없음",
  "connect.cov.item": "항목",
  "connect.cov.cellTitle": "{item} · {ch}",
  "connect.cov.ch.claude_code": "Claude Code",
  "connect.cov.ch.codex": "Codex",
  "connect.cov.ch.anthropic_api": "Anthropic API 키",
  "connect.cov.ch.openai_api": "OpenAI API 키",
  "connect.cov.ch.org_report": "조직 보고서",
  "connect.cov.it.prompt": "질문",
  "connect.cov.it.usage": "사용량",
  "connect.cov.it.files": "열어 본 파일",
  "connect.cov.it.changes": "바뀐 내용",
  "connect.cov.it.time": "시간",
  "connect.cov.it.model": "AI 모델",
  "connect.cov.it.actions": "AI가 한 작업·오류",
  "connect.cov.naNote": "이 사용 방식에는 이런 값이 없어요.",
  "connect.cov.orgNote": "조직 보고서는 하루·모델·키 합계라 이 값이 없어요.",
  "connect.cov.n.prompt.claude_code": "기록 수준 ② 이상이고 CLI의 질문 글 보내기 설정이 켜져 있을 때 질문 글이 남아요. 꺼져 있으면 글자 수만 남아요.",
  "connect.cov.n.prompt.codex": "기록 수준 ② 이상이고 Codex의 질문 글 보내기 설정이 켜져 있을 때 질문 글이 남아요.",
  "connect.cov.n.prompt.api": "게이트웨이를 거친 호출의 마지막 질문 1건이 남아요. 글 저장은 앱별 정책을 켰을 때만이에요(기본은 기본 정보만).",
  "connect.cov.n.usage.claude_code": "요청마다 새로 읽음·캐시에서 읽음·캐시에 저장·AI가 쓴 양이 와요.",
  "connect.cov.n.usage.codex": "‘새로 읽음 = 입력 − 캐시’로 맞춰요. 합계는 검증 중이에요.",
  "connect.cov.n.usage.anthropic_api": "게이트웨이가 응답에서 사용량을 읽어요.",
  "connect.cov.n.usage.openai_api": "게이트웨이가 읽어요. 스트림에 사용량이 없으면 ‘알 수 없음’이에요(0 아님).",
  "connect.cov.n.usage.org_report": "하루·모델·키 합계예요. 사람별 기록과 더하지 않아요.",
  "connect.cov.n.files.claude_code": "기록 수준 ④이고 CLI의 작업 상세 보내기 설정이 켜져 있을 때 경로가 남아요. 파일 내용은 남지 않아요.",
  "connect.cov.n.files.codex": "셸 명령에서 뽑은 추정 경로예요(기록 수준 ④).",
  "connect.cov.n.changes.claude_code": "기록 수준 ④이고 CLI의 작업 상세 보내기 설정이 켜져 있어야 해요. 고치기 전·후 값은 값마다 앞 128자까지만 와요.",
  "connect.cov.n.changes.codex": "패치 전체가 와요. 저장은 기록 수준 ④에서 해요.",
  "connect.cov.n.time.claude_code": "사용 시각·대화가 열려 있던 시간·응답 대기가 남아요. AI 사용 시간은 숫자 지표 보내기를 켜야 와요.",
  "connect.cov.n.time.codex": "사용 시각·대화가 열려 있던 시간·응답 대기가 남아요. AI 사용 시간은 보내지 않아요.",
  "connect.cov.n.time.api": "호출 시각·응답 대기가 남아요. 대화가 열려 있던 시간은 대화 헤더가 있을 때만 알아요.",
  "connect.cov.n.time.org_report": "날짜(하루 단위)만 있어요.",
  "connect.cov.n.model.claude_code": "AI 모델과 생각 깊이가 질문마다 와요.",
  "connect.cov.n.model.codex": "AI 모델과 생각 깊이가 와요. 질문과 호출은 시간 순서로 이어 붙여요(추정 연결).",
  "connect.cov.n.model.api": "AI 모델이 남아요. 생각 깊이는 요청 본문을 더 읽어야 해서 조건부예요.",
  "connect.cov.n.model.org_report": "모델별 하루 합계예요.",
  "connect.cov.n.actions.claude_code": "도구 실행·허용·거절·오류·재시도가 남아요. 명령 문자열은 기록 수준 ④이고 CLI의 작업 상세 보내기 설정이 켜져 있어야 해요.",
  "connect.cov.n.actions.codex": "명령과 출력 앞부분이 늘 와요. 저장은 기록 수준을 따라요.",
  "connect.cov.n.actions.api": "오류·재시도만 남아요. API 키 호출에는 도구 작업이 없어요.",
  "connect.cov.n.actions.org_report": "Claude Code 조직 통계의 수락·거절 합계만 있어요.",
  "connect.cov.never.q": "어떤 방법으로도 남지 않는 것은 무엇인가요?",
  "connect.cov.never.tech": "기록할 수 없는 것 · 도구가 보내지 않거나 저장하지 않아요",
  "connect.cov.never.1": "질문을 고쳐 보낸 이전 판과 입력창의 초안",
  "connect.cov.never.2": "AI의 중간 생각 글(와도 저장하지 않아요)",
  "connect.cov.never.3": "셸 명령(sed -i·Set-Content 등)으로 바꾼 파일 내용 — 명령 문자열만 남아요",
  "connect.cov.never.4": "Claude의 전체 파일 기준 표준 diff",
  "connect.cov.never.5": "기본 경로에서 Claude가 읽은 파일 내용",
  "connect.cov.dont.q": "이 시스템이 하지 않는 일은 무엇인가요?",
  "connect.cov.dont.tech": "하지 않는 일 · 목적 제한",
  "connect.cov.dont.1": "키 입력·화면·네트워크를 들여다보지 않아요.",
  "connect.cov.dont.2": "AI의 중간 생각을 저장하지 않아요.",
  "connect.cov.dont.3": "AI 기여율을 판정하지 않아요.",
  "connect.cov.src": "판정 기준 2026년 10월 · 지원표가 바뀌면 함께 바꿔요",
  "connect.days.title": "최근 14일 수집 상태",
  "connect.days.question": "기기마다 기록을 받은 날은 언제인가요?",
  "connect.days.fixedRange": "이 표는 위 기간 선택과 별도로 오늘을 포함한 최근 14일을 보여 줘요.",
  "connect.days.range": "{from} ~ {to} · 조직 시간대 {timezone} · 오늘은 진행 중",
  "connect.days.legend": "날짜별 수집 상태 범례",
  "connect.days.device": "기기",
  "connect.days.state.received": "받음",
  "connect.days.state.all_dropped": "받았지만 모두 버림",
  "connect.days.state.no_receipt": "받은 것 없음",
  "connect.days.state.before_connection": "연결 전",
  "connect.days.counts": "받음 {received} · 저장 {stored} · 중복 {duplicates} · 버림 {dropped}",
  "connect.days.unknown": "서버가 받은 기록이 없어요. 이유는 알 수 없어요.",
  "connect.days.before": "이 기기를 연결하기 전 날짜예요.",
  "connect.days.note": "받은 것이 없어도 AI를 쓰지 않았다는 뜻은 아니에요. 날짜를 선택하면 그날의 수신 건수와 버린 이유를 볼 수 있어요.",
  "connect.days.empty": "확인할 기기가 아직 없어요.",
  "connect.days.unavailable": "기기별 수집 상태를 아직 확인할 수 없어요.",
  "connect.days.revoked": "연결 해제됨",
  "connect.days.prev": "이전 기기",
  "connect.days.next": "다음 기기",
  "connect.days.page": "기기 {total}개 중 {from}~{to}",
};

export default connect;
